import {makeStyles} from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  '& .MuiButtonBase-root.MuiMenuItem-root': {
    fontSize: 12
  },
  colorBox:{
    display: "inline-block",
    height: "14px",
    width: "14px",
    minHeight: "14px",
    minWidth: "14px",
    border: "solid 1px black"
  },
  buttonAdd: {
    backgroundColor: theme.palette.mainButton.blue,
    borderRadius: 10,
    width: 137,
    textTransform: "capitalize",
    fontSize: 16,
    lineHeight: 1.875,

    "@media screen and (max-width: 480px)": {
      width: 78,
      //height: 25,
      fontSize: 12,
      borderRadius: 3,
      lineHeight: "14px",

      '& .MuiButton-startIcon': {
        margin: "0 4px 0 0",
      },

      '& svg': {
        width: 6,
        height: 6,

      }
    }
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    /*marginTop: -20*/
  },
  burgerMenuToggler: {
    display: "none",
    "@media screen and (max-width: 480px)": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 2px"
    }
  },

  directoryName: {
    display: "none",
    "@media screen and (max-width: 480px)": {
      display: "block",
      marginLeft: 30,
      fontSize: 14,
      lineHeight: 1
    }
  },

  mobileMenu: {
    display: "none",

    "@media screen and (max-width: 480px)": {
      display: "block",
      zIndex: 10,
      background: "white",
      position: "absolute",
      left: 0,
      top: -34,
      width: "100%",
      height: "100%",

      '& .MuiBox-root': {
        maxWidth: "none"
      },

      '& .MuiButtonBase-root' : {
        height: 43,
        marginBottom: 8
      }
    }
  },

}));

export default useStyles;
